import { render, staticRenderFns } from "./SelectCourses.vue?vue&type=template&id=09806ece&"
import script from "./SelectCourses.vue?vue&type=script&lang=js&"
export * from "./SelectCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports